/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import {BootstrapVue, IconsPlugin} from "bootstrap-vue";

require('./bootstrap');
require('select2');
window.moment = require('moment');
require('tempusdominus-bootstrap-4');

window.Vue = require('vue');

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// Install BootstrapVue
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);

const files = require.context('./', true, /\.vue$/i)
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

/*
Vue.component('example-component', require('./components/ExampleComponent.vue').default);
Vue.component('send-message-box', require('./components/SendMessageBox').default);
Vue.component('chat', require('./components/Chat').default);
Vue.component('date-input', require('./components/DateInput').default);
Vue.component('events-calendar', require('./components/EventsCalendar').default);
*/

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app',
});

import EventPing from "./event-ping";
window.EventPing = new EventPing();

window.ClassicEditor = require('@ckeditor/ckeditor5-build-classic');

window.bsCustomFileInput = require('bs-custom-file-input');

import * as Calendar from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import interactionPlugin from '@fullcalendar/interaction';

window.FullCalendar = Calendar;
window.dayGridPlugin = dayGridPlugin;
window.timeGridPlugin = timeGridPlugin;
window.listPlugin = listPlugin;
window.interactionPlugin = interactionPlugin;
